import Adverts from '../presentational/Adverts';

const AdvertsContainer = () => {
    return <Adverts />;
};

export default AdvertsContainer;
